export const getManageAccountsURL = (partnerId: string, baseURL: string): string => {
  const manageAccountsLink = '/am/managerAccounts/' + partnerId + '/accounts'
  return baseURL + manageAccountsLink
}

export const getUserManagementURL = (partnerId: string, baseURL: string): string => {
  const manageAccountsLink = '/am/managerAccounts/' + partnerId + '/user/management?entityId=' + partnerId
  return baseURL + manageAccountsLink
}
